import { render } from "./IndexUtilisateur.vue?vue&type=template&id=2b4edd4c"
import script from "./IndexUtilisateur.vue?vue&type=script&lang=js"
export * from "./IndexUtilisateur.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__